<template>
  <modal v-model="model" max-width="580">
    <template #title>AI Insights</template>
    <template #content>
      <p class="mt-4 mb-6">
        <strong>AI Insights</strong> provides a recommendation towards
        screening based on our estimation of whether there are
        unscreened references that may be relevant to your review.
      </p>
      <p class="mb-2">
        <strong>Recommendation</strong> indicates whether you should
        continue screening or not. It can be in one of the following
        three states:
      </p>

      <div v-for="state in adviceStates" :key="state" class="mb-2">
        <screening-advice-status-item :state="state" />
      </div>

      <div>
        The following conditions will produce a recommendation to
        <strong>Stop Screening</strong>:
      </div>

      <ul class="mb-6">
        <li>
          a consecutive streak of 40 references screened as
          <strong>Not Relevant</strong>.
        </li>
        <li>
          remaining unscreened references fall below the possibly
          relevant threshold (> 50% confidence)
        </li>
      </ul>
      <p>
        <strong>Estimated Remaining Relevant</strong> shows an
        estimated range of remaining relevant references, ranging from
        likely relevant (>= 90% confidence) to possible relevant (>=
        50% confidence) remaining references. For example:
      </p>
      <p>
        An estimation of <strong>50 - 100</strong> means there are 50
        likely relevant references &amp; 100 possibly relevant
        references remaining in the review.
      </p>
    </template>
    <template #actions>
      <v-spacer />
      <action-button @click="model = false">Close</action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';
import ScreeningAdviceStatusItem from '@/components/ReviewSummary/ScreeningAdviceStatusItem';
import { ScreeningAdviceState } from '@/enums';

export default {
  name: 'ScreeningAdviceHelpModal',
  components: {
    ActionButton,
    Modal,
    ScreeningAdviceStatusItem,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    adviceStates: Object.values(ScreeningAdviceState),
  }),
  computed: {
    model: {
      get: function () {
        return this.open;
      },
      set: function (value) {
        this.$emit('update:open', value);
      },
    },
  },
};
</script>
